import store from "@/store";

export default {
	name: "LogoutPage",

	functional: true,

	render() {
		store.dispatch( "auth/logout" );

		return <h1 class="text-h1 text-center">Logging out....</h1>;
	}
};
